import React, { Component } from 'react';
// import { get } from 'lodash';
import PT from 'prop-types';
import { connect } from 'react-redux';
import { selectPositionsForFilterMenu } from '../../../store/reducers/positions';
import { goToView } from '../../routes.global';
import {
  selectStrengthOfScheduleState,
  setSOSShowRange,
  SOS_VIEW,
} from './module/strengthOfSchedule';
import FiltersHeader from '../../../app/components/FiltersHeader';
import TableControls from '../../components/TableControls';
import FilterRangeSlider from '../../components/FilterComponents/FilterRangeSlider';
import ButtonMenu from '../../components/FilterComponents/ButtonMenu';
import PlainTable from '../../components/DataTable/PlainTable';
import classes from './strengthOfSchedule.css';
import MatchupCell from '../../components/DataTable/StatCells/MatchupCell';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'Strength of Schedule';

export class StrengthOfSchedule extends Component {
  static propTypes = {
    showStart: PT.number.isRequired,
    showEnd: PT.number.isRequired,
    calcStart: PT.number.isRequired,
    calcEnd: PT.number.isRequired,
    teams: PT.arrayOf(PT.object),
    hasLoaded: PT.bool.isRequired,
    positions: PT.arrayOf(PT.object).isRequired,
    goToView: PT.func.isRequired,
    setSOSShowRange: PT.func.isRequired,
    selectedPosition: PT.string.isRequired,
    selectedFormula: PT.number.isRequired,
    selectedYear: PT.number.isRequired,
    toolsLoaded: PT.bool.isRequired,
    loggedIn: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
  };

  static defaultProps = {
    teams: [],
  }
  state = {
    prevLogin: false,
    didFirst: false,
  }

  prepHeaders = () => {
    const { showStart, showEnd } = this.props;
    const colKeys = [];
    const colLabels = [];
    colKeys.push('team_abbr'); // need to manually add the team column key/label
    colLabels.push('Team');
    for (let i = showStart; i <= showEnd; i++) {
      colKeys.push(String(i - 1));
      colLabels.push(`Wk ${i}`);
    }
    colKeys.push('average', 'eos');
    colLabels.push('Avg. Game', 'EOS');
    return { colKeys, colLabels };
  };

  prepStats = colKeys => {
    const { teams, hasLoaded, showStart, showEnd } = this.props;
    const allStatRows = [];

    if (hasLoaded) {
      teams.forEach(team => {
        let numberOfGames = 0;
        const statRow = {};
        let ptsTotal = 0;
        let goodCount = 0;
        let badCount = 0;
        colKeys.forEach(key => {
          if (team[key] || team[key] === 0) statRow[key] = team[key];
          else if (team.games[key]) {
            // In case needs to be switched to calcRange, not ShowRange, adding this conditional here.
            if (team.games[key].week && (team.games[key].week >= showStart && team.games[key].week <= showEnd)) {
              ptsTotal += (parseFloat(team.games[key].matchup) * 10) || 0;
              goodCount += team.games[key].matchup_type === 'good' ? 1 : 0;
              badCount += team.games[key].matchup_type === 'bad' ? 1 : 0;
              if (team.games[key].opponent != 'BYE'){
                numberOfGames++;
              }
            }
            statRow[key] = {
              element:
                <MatchupCell rating={team.games[key].matchup_type}>
                  {`${team.games[key].opponent}\n${team.games[key].matchup ||
                    ''}`}
                </MatchupCell>,
              sortValue: team.games[key].matchup,
            };
          }
        });
        statRow.eos = `${goodCount}-${badCount}`;
        if (numberOfGames === 0){
          numberOfGames = 1;
        }
        statRow.average = Math.round(((ptsTotal / (numberOfGames * 10)) + Number.EPSILON) * 10) / 10;
        allStatRows.push(statRow);
      });
    }
    return allStatRows;
  };

  handleShowWeeksChange = range => {
    const { min, max } = range;
    const { showStart, showEnd } = this.props;
    if (min !== showStart || max !== showEnd) {
      this.props.setSOSShowRange(range);
    }
  };

  handleCalcWeeksChange = range => {
    const { min, max } = range;
    const { calcStart, calcEnd } = this.props;
    if (min !== calcStart || max !== calcEnd) {
      this.props.goToView(SOS_VIEW, {
        query: { calcStart: min, calcEnd: max },
      });
    }
  };

  handleChangePosition = (event, { value }) => {
    if (this.props.selectedPosition !== value) {
      this.props.goToView(SOS_VIEW, { query: { position: value } });
    }
  };

  handleChangeYear = (event, { value }) => {
    if (this.props.selectedYear !== value) {
      this.props.goToView(SOS_VIEW, { query: { year: value } });
    }
  };

  handleChangeFormula = (event, { value }) => {
    if (this.props.selectedFormula !== value) {
      this.props.goToView(SOS_VIEW, { query: { formulaId: value } });
    }
  };

  render() {
    const { hasLoaded, numWeeks, positions, selectedPosition,
      selectedFormula, selectedYear, toolDescriptions,
      toolsLoaded } = this.props;
    const { showStart, showEnd, calcStart, calcEnd } = this.props;
    const showSliderOptions = {
      value: { min: showStart, max: showEnd },
      minValue: 1,
      maxValue: selectedYear >= 2021 ? 18 : 17,
      formatLabel: value => `Wk${value}`,
      onChangeComplete: this.handleShowWeeksChange,
      sliderLabel: 'Show Range:',
    };
    const calcSliderOptions = {
      value: { min: calcStart, max: calcEnd },
      minValue: 1,
      maxValue: selectedYear >= 2021 ? 18 : 17,
      formatLabel: value => `Wk${value}`,
      onChangeComplete: this.handleCalcWeeksChange,
      sliderLabel: 'Calculate Range:',
    };
    const { colKeys, colLabels } = this.prepHeaders();
    const allStatRows = this.prepStats(colKeys);
    const colGroups = [{ name: '', columns: colKeys, colLabels }];

    return (
      <div className={classes.wrapper}>
        <FiltersHeader
          title={pageTitle}
          description={toolsLoaded && toolDescriptions.tool_descriptions.strength_of_schedule.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.strength_of_schedule.text}
            />)}
          seasonType="seasons"
          statType="stats"
          selectedYear={selectedYear}
          selectedProfile={selectedFormula}
          onChangeProfile={this.handleChangeFormula}
          onChangeYear={this.handleChangeYear}
          showDate={false}
        >
          <FilterRangeSlider {...calcSliderOptions} />
          <FilterRangeSlider {...showSliderOptions} />
          <ButtonMenu
            choices={positions}
            label={'Position:'}
            activeItem={selectedPosition}
            onChange={this.handleChangePosition}
          />
        </FiltersHeader>

        <TableControls matchup statsKeyRight density={false} colGroups={[{ columns: ['team','Week #','Avg. Game','EOS'] }]} />
        {hasLoaded && (
          <PlainTable
            data={allStatRows}
            colGroups={colGroups}
            teamColor={''}
            centerFirstCol
            fittedText
            equalWidthCols
            className={classes.sosTable}
            initialSortColumn={'average'}
            sortAscending={false}
          />
        )}
      </div>
    );
  }
  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
    this.setState({ didFirst: true });
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.didFirst && this.state.prevLogin !== prevProps.loggedIn) {
      this.setState({ prevLogin: prevProps.loggedIn });
      const { selectedPosition, selectedYear, selectedFormula } = this.props;
      this.props.goToView(
        SOS_VIEW, {
          query: { year: selectedYear, formulaId: selectedFormula, position: selectedPosition },
          updateQuery: false,
        },
      );
    }
  }
}

const mapStateToProps = state => {
  const {
    stats,
    hasLoaded,
    position: selectedPosition,
    formulaId: selectedFormula,
    year: selectedYear,
    showStart,
    showEnd,
    calcStart,
    calcEnd,
  } = selectStrengthOfScheduleState(state);
  const positions = selectPositionsForFilterMenu(state, 'stats');
  const { teams, num_of_weeks: numWeeks } = stats;
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);
  const loggedIn = state.auth.loggedIn;
  return {
    numWeeks,
    teams,
    hasLoaded,
    positions,
    selectedPosition,
    selectedFormula,
    selectedYear,
    showStart,
    showEnd,
    calcStart,
    calcEnd,
    toolDescriptions,
    toolsLoaded,
    loggedIn,
  };
};

const mapDispatchToProps = {
  goToView,
  setSOSShowRange,
};

export default connect(mapStateToProps, mapDispatchToProps)(StrengthOfSchedule);



// WEBPACK FOOTER //
// ./src/app/views/StrengthOfSchedule/StrengthOfSchedule.js